/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function() {
  cMvScrollBtnTorigger();
  cSmoothScrollTrigger();
  cSlideProductTorigger();
  cTabChangeTrigger();
  cAllTabChangeTrigger();
  cDobbleSlideTrigger();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      cMvScrollBtnTorigger();
      cSmoothScrollTrigger();
      cSlideProductTorigger();
      cTabChangeTrigger();
      cAllTabChangeTrigger();
      cDobbleSlideTrigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      cMvScrollBtnTorigger();
      cSmoothScrollTrigger();
      cSlideProductTorigger();
      cTabChangeTrigger();
      cAllTabChangeTrigger();
      cDobbleSlideTrigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
      cMvScrollBtnTorigger();
      cSmoothScrollTrigger();
      cSlideProductTorigger();
      cTabChangeTrigger();
      cAllTabChangeTrigger();
      cDobbleSlideTrigger();
    });
}

/****************************************
    メインビジュアルのアニメーションボタンのJS
****************************************/
function cMvScrollBtnTorigger() {
    if (document.querySelectorAll('.shopify-section--slideshow').length) {
        cMvScrollBtn();
    }
};

function cMvScrollBtn() {
  const sections = document.querySelectorAll('.shopify-section--slideshow');

  sections.forEach(section => {
    const scrollBtn = section.querySelector('.c-slideshow__animbtn');
    
    scrollBtn?.addEventListener('click', function() {
      const nextSection = section.nextElementSibling;

      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  })
}


/****************************************
     遅延関数のJS
****************************************/
function customDebounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}


/****************************************
     プログレスバーのJS
****************************************/
function updateProgressBar(slick, currentSlide, $progressBarLabel) {
    if (slick && slick.options && slick.options.slidesToScroll) {
        const slidesToScroll = slick.options.slidesToScroll;
        const totalSlides = Math.ceil(slick.slideCount / slidesToScroll);
        const currentSlideIndex = Math.floor(currentSlide / slidesToScroll);
        const width = 100 / totalSlides;
        const calc = (currentSlideIndex / totalSlides) * 100;

        $progressBarLabel
            .css('left', calc + '%')
            .css('width', width + '%');
    }
}


/****************************************
     タブ切り替えセクション（Default）
****************************************/
function cTabChangeTrigger() {
    if (document.querySelectorAll('.c-tab__section').length) {
        cTabChange();
    }
};

function cTabChange() {
    const sections = document.querySelectorAll('.c-tab__section');
    
    sections.forEach((section) => {
        const $slick = $(section).find('.c-category__tabbox.slider');
        const tabList = section.querySelectorAll('.c-tab__tablist');
        const tabContent = section.querySelectorAll('.c-tab__content');

        let slideNum = $(section).data('slideNum');
        let productNum = $slick.data('mainProductNum');

        let activeContentNum = $(tabContent[0]).find('.c-category__content__inner').data('productNum');
        productNumCheck($(tabContent[0]));
    
        function activateTab(tab) {
            section.querySelector('.is-active').classList.remove('is-active');
            tab.classList.add('is-active');
            section.querySelector('.is-show').classList.remove('is-show');
            const aryTabs = Array.prototype.slice.call(tabList);
            const index = aryTabs.indexOf(tab);
            tabContent[index].classList.add('is-show');

            if (section.classList.contains('c-slidetab__section')) {
                activeContentNum = $(tabContent[index]).find('.c-category__content__inner').data('productNum');
                productNumCheck($(tabContent[index]));
            }
        }

        function productNumCheck (el) {
            const mediaQuery999 = window.matchMedia('(max-width: 999px)');
            const mediaQuery740 = window.matchMedia('(max-width: 740px)');
    
            function handleMediaQueryChange() {
                let maxProductNum;
                if (mediaQuery740.matches) {
                    ;
                } else if (mediaQuery999.matches) {
                    if (slideNum == 10 || slideNum == 8) {
                      maxProductNum = 7;
                    } else {
                      maxProductNum = 5;
                    }
                } else {
                    if (slideNum == 10) {
                      maxProductNum = 9;
                    } else if (slideNum == 8) {
                      maxProductNum = 7;
                    } else {
                      maxProductNum = 5;
                    }
                }
    
                if (!mediaQuery740.matches && activeContentNum <= maxProductNum) {
                    el.addClass('c-stack-content');
                } else if (!mediaQuery740.matches && activeContentNum > maxProductNum) {
                    el.removeClass('c-stack-content');
                }
            }
    
            handleMediaQueryChange();
            mediaQuery999.addListener(handleMediaQueryChange);
            mediaQuery740.addListener(handleMediaQueryChange);
        }

        tabList.forEach((tab, i) => {
            tab.addEventListener('click', () => {
                productNum = $slick.data('mainProductNum');
                activateTab(tab);
            });
        });

        function initializeSlick() {
            $slick.not('.slick-initialized').slick({
                autoplay: false,
                arrows: true,
                dots: false,
                // slidesToShow: 4,
                // swipeToSlide: true,
                slidesToScroll: 2,
                infinite: false,
                variableWidth: true,
                prevArrow: '<button class="c-arrow__btn c-small-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
                nextArrow: '<button class="c-arrow__btn c-small-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
            });
        }

        function checkTabWidth() {
            let totalWidth = 0;
            $(tabList).each(function() {
                totalWidth += $(this).outerWidth(true);
            });
    
            const tabBoxWidth = $slick.width();
    
            if (totalWidth > tabBoxWidth) {
                if (!$slick.hasClass('slick-initialized')) {
                    initializeSlick();
                }
                // $(tabList).each(function() {
                //     $(this).removeAttr('aria-hidden');
                //     $(this).removeAttr('tabindex');
                // });
            } else {
                if ($slick.hasClass('slick-initialized')) {
                    $slick.slick('unslick');
                    $(section).find('.c-category__tabbox.slider.slick-initialized').slick('unslick');
                }
            }
        }
      
        window.addEventListener("load",() => {
            checkTabWidth();
        }, false);

        const debouncedCheckTabWidth = customDebounce(checkTabWidth, 200);
        window.addEventListener("resize", debouncedCheckTabWidth, false);
    
        checkTabWidth();
    });
}


/****************************************
     タブ切り替えセクション（All Items）
****************************************/
function cAllTabChangeTrigger() {
    if (document.querySelectorAll('.c-allproducts__section').length) {
        cAllTabChange();
    }
};

function cAllTabChange() {
    const sections = document.querySelectorAll('.c-allproducts__section');
    
    sections.forEach((section) => {
        const breakPoint = 741;
        const $slick = $(section).find('.c-category__tabbox.slider');
        const tabList = section.querySelectorAll('.c-tab__tablist');

        const mobileTabBox = $(section).find('.c-allproducts__tabbox');

        const categoryContent = $(section).find('.c-category__content');
        const mobileLimit = $(section).data('mobileLimit');
        const pcLimit = $(section).data('pcLimit');

        let scrollNum = 2;
        let $tabOriginalList, $tabClonedList;
        let isSliding = false;
      
        function initializeSlick() {
            const totalSlides = $slick.children().length;

            const remainingSlides = totalSlides % scrollNum;
            if (remainingSlides !== 0) {
                scrollNum = 1;
            } else {
                scrollNum = 2;
            }

            $slick.on('init', function(event, slick) {
                $tabOriginalList = $(section).find('.c-category__tablist:not(.slick-cloned)');
                $tabClonedList = $(section).find('.c-category__tablist.slick-cloned');
                const $tabContent = $(section).find('.c-tab__content');

                function handleTabClick(tab) {
                    if (isSliding) return;
                  
                    const index = parseInt($(tab).attr('data-slick-index')) % $tabOriginalList.length;

                    const $activeTab = $(section).find('.c-category__tabbox .is-active');
                    if ($activeTab.length) {
                        $activeTab.removeClass('is-active');
                    }

                    $tabClonedList.eq(index + scrollNum).addClass('is-active');
                    $tabOriginalList.eq(index).addClass('is-active');

                    $(mobileTabBox).find('li').removeClass('is-active');
                    $(mobileTabBox).find('input').prop('checked', false);
                    $(mobileTabBox).find('li').eq(index).addClass('is-active');
                    $(mobileTabBox).find('li').eq(index).prop('checked', true);

                    const $activeContent = $(section).find('.c-tab__content.is-show');
                    if ($activeContent.length) {
                        $activeContent.removeClass('is-show');
                    }

                    $tabContent.eq(index).addClass('is-show');
                    moveTabToFirst(index);
                }

                $tabOriginalList.each(function(i, tab) {
                    $(tab).on('click', function() {
                        handleTabClick(tab);
                    });
                });

                $tabClonedList.each(function(i, tab) {
                    $(tab).on('click', function() {
                        handleTabClick(tab);
                    });
                });

                const $activeMobileTab = $(mobileTabBox).find('li.is-active');
                if ($activeMobileTab.length) {
                    const activeIndex = $activeMobileTab.index();
                    if (activeIndex > 0 ) {
                        const $activePcTab = $(section).find('.c-category__tabbox .is-active');
                        if ($activePcTab.length) {
                            $activePcTab.removeClass('is-active');
                        }
                      
                        $tabOriginalList.eq(activeIndex).addClass('is-active');
                        $tabClonedList.eq(activeIndex + scrollNum).addClass('is-active');
                    }
                }
            });

            $slick.not('.slick-initialized').slick({
                autoplay: false,
                arrows: true,
                dots: false,
                slidesToShow: scrollNum,
                slidesToScroll: scrollNum,
                swipeToSlide: true,
                infinite: false,
                variableWidth: true,
                prevArrow: '<button class="c-arrow__btn c-small-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
                nextArrow: '<button class="c-arrow__btn c-small-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
            });

            $slick.on('afterChange', function(event, slick, currentSlide) {
                setTimeout(() => {
                  isSliding = false;
                }, '50');
            });

            $slick.on('swipe', function(event, slick, direction) {
                isSliding = true;
            });
        }

        function mobileProductHide() {
            categoryContent.each(function(index, content) {
                const contentProducts = $(content).find('.c-product-item');
                if (mobileLimit < pcLimit) {
                    contentProducts.each(function(index, product) {
                        if (index >= mobileLimit) {
                            $(product).addClass('md-max-hidden');
                        } else {
                            $(product).removeClass('md-max-hidden');
                        }
                    });
                } else {
                    contentProducts.each(function(index, product) {
                        if (index >= pcLimit) {
                            $(product).addClass('md-max-hidden');
                        } else {
                            $(product).removeClass('md-max-hidden');
                        }
                    });
                }
            });
        }

        function moveTabToFirst(index) {
            $slick.slick('slickGoTo', index, true);
        }

        function mobileSelectBox() {
            $(mobileTabBox).off().on('click', function() {
                if ($(this).hasClass('is-open')) {
                    $(this).removeClass('is-open');
                    $(section).removeClass('c-mobile-tab-open');
                } else {
                    $(this).addClass('is-open');
                    $(section).addClass('c-mobile-tab-open');
                }
            });
          
            $(mobileTabBox).find('li').off().on('click',function(e){
              if($(this).hasClass('is-active')){
                $(mobileTabBox).removeClass('is-open');
                e.stopPropagation();
              } else {
                $(mobileTabBox).find('li').removeClass('is-active');
                $(mobileTabBox).find('input').prop('checked', false);
                $(this).addClass('is-active');
                $(this).prop('checked', true);

                mobileActivateTab($(this));
              }
            });
        }

        function mobileActivateTab(tab) {
            const index = $(tab).index();
            $(section).find('.c-tab__content').removeClass('is-show');
            $(section).find('.c-tab__content').eq(index).addClass('is-show');

            const $activeTab = $(section).find('.c-category__tabbox .is-active');
            if ($activeTab.length) {
                $activeTab.removeClass('is-active');
            }

            if ($tabClonedList && $tabOriginalList) {
              $tabOriginalList.eq(index).addClass('is-active');
              $tabClonedList.eq(index + scrollNum).addClass('is-active');
            }
        }

        function checkTabWidth() {
            if (breakPoint < window.innerWidth) {
                let totalWidth = 0;
                $(tabList).each(function() {
                    totalWidth += $(this).outerWidth(true);
                });
        
                const tabBoxWidth = $slick.width();
        
                if (totalWidth > tabBoxWidth) {
                    if (!$slick.hasClass('slick-initialized')) {
                        initializeSlick();
                    }
                    $(tabList).each(function() {
                        $(section).addClass('c-valid-slick');
                    });
                } else {
                    if ($slick.hasClass('slick-initialized')) {
                        $(section).find('.c-category__tabbox.slider.slick-initialized').slick('unslick');
                        $(section).removeClass('c-valid-slick');
                    }
                }
            } else {
                $(section).find('.c-category__tabbox.slider.slick-initialized').slick('unslick');
                $(section).removeClass('c-valid-slick');

                mobileSelectBox();
                mobileProductHide();
            }
        }

        window.addEventListener("load",() => {
            checkTabWidth();
        }, false);

        const debouncedCheckTabWidth = customDebounce(checkTabWidth, 200);
        window.addEventListener("resize", debouncedCheckTabWidth, false);
    });
}


/****************************************
    商品詳細ページの矢印アイコンのJS
****************************************/
function cProductMediaArrowTorigger() {
    if (document.querySelectorAll('.c-product__media').length) {
        cProductMediaArrow();
    }
};

function cProductMediaArrow() {
    const productMedia = document.querySelector('.c-product__media');
    const prevBtn = productMedia.querySelector('.flickity-button.previous');
    const nextBtn = productMedia.querySelector('.flickity-button.next');

    prevBtn.classList.add('c-arrow__btn c-arrow__prev animate-icon-horizontal', 'is-reverse');
    nextBtn.classList.add('c-arrow__btn c-arrow__next animate-icon-horizontal');

    const prevSpan = document.createElement('span');
    prevSpan.classList.add('c-arrow__svg');
    prevBtn.appendChild(prevSpan);

    const nextSpan = document.createElement('span');
    nextSpan.classList.add('c-arrow__svg');
    nextBtn.appendChild(nextSpan);
}


/****************************************
     2行のスライダーセクション
****************************************/
function cDobbleSlideTrigger() {
    if (document.querySelectorAll('.c-slidetab__section').length) {
        cDobbleSlide();
    }
};

function cDobbleSlide() {
    const sections = document.querySelectorAll('.c-slidetab__section');
    
    sections.forEach((section) => {
        const $slicks = $(section).find('.c-category__content__inner.slider');
        const $progressBars = $(section).find('.c-progress');
        const $progressBarLabels = $(section).find('.c-progress__label');

        const categoryContent = $(section).find('.c-category__content');
        const mobileLimit = $(section).data('mobileLimit');
        const pcLimit = $(section).data('slideNum');

        let slideNum = $(section).data('slideNum') / 2;
        let slideNumMedium = 0;
        if (slideNum >= 4) {
          slideNumMedium = 4;
        } else {
          slideNumMedium = 3;
        }

        let sliderBool;
        const breakPoint = 741;
      
        function createSlider($slick, $progressBar, $progressBarLabel) {
          $slick.not('.slick-initialized').slick({
              autoplay: false,
              speed: 600,
              arrows: true,
              dots: false,
              slidesPerRow: slideNum,
              slidesToShow: 1,
              rows: 2,
              infinite: false,
              prevArrow: '<button class="c-arrow__btn c-large-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse"><span class="c-arrow__svg"></span></button>',
              nextArrow: '<button class="c-arrow__btn c-large-arrow__btn c-arrow__next animate-icon-horizontal"><span class="c-arrow__svg"></span></button>',
              responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesPerRow: slideNumMedium,
                    }
                }
            ]
          });
          
          $slick.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
              updateProgressBar(slick, nextSlide, $progressBarLabel);
          });

          $slick.on('init', function(event, slick) {
              updateProgressBar(slick, 0, $progressBarLabel);
          });

          const initialSlide = $slick.slick('slickCurrentSlide');
          updateProgressBar($slick.slick('getSlick'), initialSlide, $progressBarLabel);
        }

        function mobileProductHide() {
            categoryContent.each(function(index, content) {
                const contentProducts = $(content).find('.c-product-item');
                if (mobileLimit < pcLimit) {
                    contentProducts.each(function(index, product) {
                        if (index >= mobileLimit) {
                            $(product).addClass('md-max-hidden');
                        } else {
                            $(product).removeClass('md-max-hidden');
                        }
                    });
                } else {
                    contentProducts.each(function(index, product) {
                        if (index >= pcLimit) {
                            $(product).addClass('md-max-hidden');
                        } else {
                            $(product).removeClass('md-max-hidden');
                        }
                    });
                }
            });
        }

        function handleResize() {
          if (breakPoint < window.innerWidth && !sliderBool) {
              $slicks.each(function(index) {
                  createSlider($($slicks[index]), $($progressBars[index]), $($progressBarLabels[index]));
              });
              sliderBool = true;
              $(section).removeClass('c-stack-slick');
          } else if (breakPoint >= window.innerWidth && sliderBool) {
              $(section).find('.c-category__content__inner.slider.slick-initialized').slick('unslick');
              sliderBool = false;
              $(section).addClass('c-stack-slick');
              mobileProductHide();
          }
        }

        window.addEventListener("load",() => {
            if (breakPoint < window.innerWidth) {
                $slicks.each(function(index) {
                    createSlider($($slicks[index]), $($progressBars[index]), $($progressBarLabels[index]));
                });
                sliderBool = true;
                $(section).removeClass('c-stack-slick');
            } else {
                sliderBool = false;
                $(section).addClass('c-stack-slick');
                mobileProductHide();
            }
        }, false);

        const debouncedHandleResize = customDebounce(handleResize, 200);
        window.addEventListener("resize", debouncedHandleResize, false);
    });
}


/****************************************
    商品一覧スライダーのJS
****************************************/
function cSlideProductTorigger() {
    if (document.querySelectorAll('.c-productlist__section').length) {
        cSlideProduct();
    }
};

function cSlideProduct() {
    $('.c-productlist__section').each(function() {
        const $section = $(this);
        const $slick = $(this).find('.c-productlist__inner.slider');
        const $progressBar = $(this).find('.c-progress');
        const $progressBarLabel = $(this).find('.c-progress__label');

        const productNum = $slick.data('productNum');
        const slideNum = $slick.data('slideNum');
        const columnNum = $slick.data('columnNum');

        const mediaQuery999 = window.matchMedia('(max-width: 999px)');
        const mediaQuery740 = window.matchMedia('(max-width: 740px)');
        const mediaQuery479 = window.matchMedia('(max-width: 479px)');

        function handleMediaQueryChange() {
            let maxProductNum;
            if (mediaQuery479.matches) {
                maxProductNum = 2;
            } else if (mediaQuery740.matches) {
                maxProductNum = 3;
            } else {
                maxProductNum = 4;
            }

            if (productNum <= maxProductNum || slideNum <= maxProductNum) {
                $section.addClass('c-stack-slick');
            } else {
                $section.removeClass('c-stack-slick');
            }

            if (!mediaQuery999.matches && productNum === 5) {
                $progressBar.addClass('c-display__none');
            } else {
                $progressBar.removeClass('c-display__none');
            }
        }

        handleMediaQueryChange();
        const debouncedHandleMediaQueryChange = customDebounce(handleMediaQueryChange, 200);
        mediaQuery999.addListener(debouncedHandleMediaQueryChange);
        mediaQuery740.addListener(debouncedHandleMediaQueryChange);
        mediaQuery479.addListener(debouncedHandleMediaQueryChange);

        $slick.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            updateProgressBar(slick, nextSlide, $progressBarLabel);
        });

        $slick.on('init', function(event, slick) {
            updateProgressBar(slick, 0, $progressBarLabel);
        });

        $slick.not('.slick-initialized').slick({
            autoplay: false,
            speed: 600,
            arrows: true,
            dots: false,
            slidesToShow: columnNum,
            slidesToScroll: columnNum,
            infinite: false,
            prevArrow: '<button class="c-arrow__btn c-medium-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
            nextArrow: '<button class="c-arrow__btn c-medium-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 741,
                    settings: {
                        slidesToShow: 3.4,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.64,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        const initialSlide = $slick.slick('slickCurrentSlide');
        updateProgressBar($slick.slick('getSlick'), initialSlide, $progressBarLabel);
    });
};
window.cSlideProductTorigger = cSlideProductTorigger;


/****************************************
     quick-buy-drawer のJS
****************************************/
function cQuickBuyDrawerTrigger() {
    if (document.querySelectorAll('.c-slidetab__section quick-buy-popover, .c-slidetab__section quick-buy-drawer, .c-productlist__section quick-buy-popover, .c-productlist__section quick-buy-drawer, .c-allproducts__section quick-buy-popover, .c-allproducts__section quick-buy-drawer').length) {
        cQuickBuyDrawer();
    }
};

function cQuickBuyDrawer() {
  const popovers = document.querySelectorAll('.c-slidetab__section quick-buy-popover, .c-productlist__section quick-buy-popover, .c-allproducts__section quick-buy-popover');
  const drawers = document.querySelectorAll('.c-slidetab__section quick-buy-drawer, .c-productlist__section quick-buy-drawer, .c-allproducts__section quick-buy-drawer');

  function handleSwitch(els, isDrawer) {
    els.forEach(el => {
        const originalParent = el.parentElement;
        const placeholder = document.createElement('div');
        placeholder.style.display = 'none';
        originalParent.insertBefore(placeholder, el);
  
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'open') {
                    const isDrawerOpen = el.hasAttribute('open');
                    if (isDrawerOpen) {
                        document.body.appendChild(el);
                        if (isDrawer) {
                            setTimeout(() => {
                                el.classList.add('c-moved');
                            }, 800);
                        } else {
                            el.classList.add('c-moved');
                        }
                    } else {
                        el.classList.remove('c-moved');
                        if (isDrawer) {
                            setTimeout(() => {
                                originalParent.insertBefore(el, placeholder);
                            }, 600);
                        } else {
                            originalParent.insertBefore(el, placeholder);
                        }
                    }
                }
            });
        });
  
        observer.observe(el, { attributes: true });
    });
  }

  function handleResize() {
      if (window.innerWidth <= 740) {
          handleSwitch(popovers, false);
      } else {
          handleSwitch(drawers, true);
      }
  }

  const debouncedHandleResize = customDebounce(handleResize, 200);
  window.addEventListener("resize", debouncedHandleResize, false);
  handleResize();
}
window.cQuickBuyDrawerTrigger = cQuickBuyDrawerTrigger;


/****************************************
     トップへ戻るボタン
****************************************/
function cSmoothScrollTrigger() {
    if (document.querySelectorAll('.c-smoothscroll').length) {
        cSmoothScroll();
    }
};

function cSmoothScroll() {
    let viewOffset = 160;
    const smoothScrollEl = document.querySelector('.c-smoothscroll');

    function viewSmoothScroll() {
        if (window.pageYOffset > viewOffset) {
            smoothScrollEl.classList.add('c-view');
        } else {
            smoothScrollEl.classList.remove('c-view');
        }
    }

    function handleResize() {
        if (window.innerWidth <= 740 && smoothScrollEl.classList.contains('c-hidden')) {
            smoothScrollEl.classList.remove('c-view');
            window.removeEventListener('scroll', viewSmoothScroll);
        } else {
            viewSmoothScroll();
            window.addEventListener('scroll', viewSmoothScroll);
        }
    }

    smoothScrollEl.addEventListener('click', function() {
        window.scroll({ top: 0, behavior: "smooth" });
    });

    const debouncedHandleResize = customDebounce(handleResize, 200);
    window.addEventListener("resize", debouncedHandleResize, false);
    handleResize();
}
                                   

/****************************************
    ドロワーメニューの開閉JS
****************************************/
$(document).ready(function() {
    $(document).on('click', '.c-toggle__title', function() {
        $(this).next('.c-toggle__content').slideToggle();
        $(this).toggleClass('is-active');
    });
});